/* import __COLOCATED_TEMPLATE__ from './seller-posting-apply-button.hbs'; */
import clsx from 'clsx';
import moment from 'moment';
import Component from '@ember/component';
import { readOnly } from '@ember/object/computed';
import { computed } from '@ember/object';
import { ASSIGNMENT } from 'sh-www/models/assignment';
import { APPLICATION } from 'sh-www/models/application';

/** @module */
const SellerPostingApplyButton = Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {boolean} */
  isExpired: computed('data.deadline', function() {
    return moment(this.get('data.deadline')).isBefore(moment());
  }),

  /** @type {boolean} */
  hasPendingApplication: computed(
    'data.applications.@each.status',
    function () {
      return !!this.get('data.applications').find(function (application) {
        return APPLICATION.SIMPLE_STATUS_MAPPING[
          APPLICATION.SIMPLE_STATUS.PENDING
        ].includes(application.get('status'));
      });
    }
  ),

  /** @type {boolean} */
  canApply: computed(
    'isExpired',
    'hasPendingApplication',
    'data.type',
    function () {
      if (this.get('data.type') !== ASSIGNMENT.TYPES.STANDARD) {
        return !this.get('isExpired');
      }

      return !this.get('isExpired') && !this.get('hasPendingApplication');
    }
  ),

  /** @type {string} */
  buttonClasses: computed('canApply', function() {
    return clsx(
      'seller-posting__apply',
      !this.canApply && 'seller-posting__apply--disabled',
    );
  }),

  /** @type {string} */
  idWithSlug: readOnly('data.idWithSlug'),

  /** @type {string} */
  tooltip: computed('isExpired', 'hasPendingApplication', function() {
    if (this.isExpired) {
      return 'This posting has expired and is no longer accepting applications';
    } else if (this.hasPendingApplication) {
      return 'You already have a pending application';
    } else return null;
  }),
});

export default SellerPostingApplyButton;
